<template>
  <Layout>
    <Card class="w-full">
      <template slot="header">
        <div
          class="is-flex is-justify-content-space-between w-full is-align-items-center"
        >
          <div class="is-size-4 has-text-weight-bold">Validar</div>
        </div>
      </template>
      <template slot="content">
        <section
          class=" border-has-background-black is-half column border p-5"
          style="margin: 0 auto;"
        >
          <div>
            <div class="mb-5">
              <h3 class="mb-3 has-text-weight-bold">
                <font-awesome-icon
                  :icon="['fas', 'store']"
                  custom-size="default"
                  class="mr-1"
                />
                Selecciona un local
              </h3>
              <b-field>
                <b-select
                  expanded
                  placeholder="Elige una opción"
                  v-model="local"
                  @input="() => $localStorage.set('local', local)"
                >
                  <option
                    v-for="localItem in localList"
                    :value="localItem.id"
                    :key="localItem.id"
                  >
                    {{ localItem.name }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <h3 class="mb-3 has-text-weight-bold">
              <font-awesome-icon
                :icon="['fas', 'credit-card']"
                custom-size="default"
                class="mr-1"
              />
              Ingrese su N° Documento
            </h3>
            <b-field
              :type="{ 'is-danger': $v.document.$error }"
              :message="[
                {
                  'Requerido. Ingresa tu N° Documento':
                    !$v.document.required && $v.document.$error
                },
                {
                  'Incorrecto. Ingresa tu N° Documento':
                    !$v.document.numeric && $v.document.$error
                }
              ]"
            >
              <b-input
                v-model="document"
                placeholder="N° Documento"
                name="document"
                @keyup.enter.native="validateDocument"
                style="flex: 1"
              />
              <Button variant="secondary">
                <div class="is-clickable is-flex " @click="openQrModal">
                  <p class="mr-2 text-xs">Escáner QR</p>
                  <img src="@/assets/scan.png" width="20" alt="Leer QR" />
                </div>
              </Button>
            </b-field>
            <div class="is-flex is-justify-content-flex-end">
              <Button
                variant="main"
                class="ml-2"
                :spinner="isLoading"
                @click.native="validateDocument"
              >
                Validar
              </Button>
            </div>
          </div>
        </section>
        <b-modal v-model="qrModalActive" has-modal-card trap-focus>
          <div class="modal-card" style="width: auto;">
            <header class="modal-card-head">
              <p class="modal-card-title">Escanear QR</p>
              <button
                type="button"
                class="delete"
                @click="qrModalActive = false"
              />
            </header>
            <section class="modal-card-body">
              <QrcodeStream
                v-if="qrModalActive"
                :camera="camera"
                @detect="onQrDecode"
                @init="onQrError"
                style="width: 300px; height: 300px;"
              />
            </section>
          </div>
        </b-modal>
      </template>
    </Card>
  </Layout>
</template>

<script>
import { required, numeric } from "vuelidate/lib/validators";
import Button from "@/components/form/Button";
import Layout from "@/components/Layout";
import Card from "@/components/base/Card";
import LocalService from "@/services/validador/LocalService";
import CompanyProviderService from "@/services/validador/CompanyProviderService";
import { QrcodeStream } from "vue-qrcode-reader";
export default {
  props: {
    option: Number,
    logo: String
  },
  components: {
    Button,
    Layout,
    Card,
    QrcodeStream
  },
  data() {
    return {
      isLoading: false,
      document: null,
      local: null,
      localList: [],
      resultsProviders: [],
      qrModalActive: false,
      camera: "rear"
    };
  },
  validations: {
    document: { required, numeric }
  },
  methods: {
    openQrModal() {
      this.qrModalActive = true;
    },
    async onQrDecode(promise) {
      try {
        const { content } = await promise;
        if (!content) return;
        this.qrModalActive = false;
        await this.getCompanyProviders(content, this.local);
        this.getRouteValidateDocument(content, this.local);
      } catch (error) {
        console.error(error);
      }
    },
    async onQrError(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "OverconstrainedError") {
          this.camera = "auto";
        } else if (error.name === "NotAllowedError") {
          this.errorMessage("Permiso de cámara denegado");
          this.qrModalActive = false;
        } else if (error.name === "NotFoundError") {
          this.errorMessage("No se encontró cámara en el dispositivo");
          this.qrModalActive = false;
        } else {
          this.errorMessage("No se pudo iniciar la cámara");
          this.qrModalActive = false;
        }
      }
    },
    errorMessage(msg) {
      this.$store.commit("settings/SET_ALERT", {
        isAlert: true,
        type: "D",
        msg
      });
    },
    async getLocals() {
      this.isLoading = true;
      try {
        const response = await LocalService.getLocalList();
        this.localList = response.data;
        const isLocalSaved = this.$localStorage.get("local");

        if (isLocalSaved) {
          this.local = isLocalSaved;
        } else {
          this.local = this.localList[0].id;
          this.$localStorage.set("local", this.local);
        }
      } catch (error) {
        this.showMessage();
      } finally {
        this.isLoading = false;
      }
    },
    async validateDocument() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        await this.getCompanyProviders(this.document, this.local);
        this.getRouteValidateDocument(this.document, this.local);
      }
    },
    async getCompanyProviders(document, local) {
      this.isLoading = true;
      try {
        const response = await CompanyProviderService.getCompanyProvidersByDocument(
          {
            num_document: document,
            local_id: local
          }
        );
        this.resultsProviders = response.data;
      } catch (error) {
        this.showMessage();
      } finally {
        this.isLoading = false;
      }
    },
    getRouteValidateDocument(document, local) {
      if (this.resultsProviders.length > 1) {
        this.$router.push({
          name: "validate-document",
          query: {
            document: document,
            local: local
          }
        });
      } else {
        this.$router.push({
          name: "validate-product-list",
          params: {
            company_provider_id: this.resultsProviders[0].id
          },
          query: {
            document: document,
            local: local
          }
        });
      }
    }
  },
  created() {
    this.getLocals();
  }
};
</script>
